import React, { useCallback, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons'
import { useForm } from 'react-hook-form'
import { oncopy } from '../../../utils/func'
import { getCopyText } from './util'
import axios from 'axios';
import message, { Message } from '../../common/Message'
import Card from './card'
import {
  Input,
  Loading
} from '../../common'

let timer: any = null

interface Iprops {
  pClassName?: string
  onClose?: () => void
  openNewTab: () => void
  isM2m?: boolean
  texts?: Array<any>
  data: {
    ad?: boolean
    address?: string
    bedroom?: string
    distance?: number
    first_available?: string
    link?: string
    photo?: string
    price?: number
    source?: number
  }
}

function Footer(props: Iprops) {
  const {
    data,
    onClose,
    openNewTab,
    pClassName,
  } = props
  let [isShare, setIsShare] = useState(false)
  let [loading, setloading] = useState(false)

  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: ""
    }
  });

  const clearTimer = useCallback(() => {
    timer && window.clearTimeout(timer)
    setloading(false)
  }, [setloading])

  const setTimer = useCallback((time = 3) => {
    timer && clearTimer()
    setloading(true)
    timer = window.setTimeout(() => {
      clearTimer()
    }, time * 1000)
  }, [clearTimer, setloading])

  const onFormSummit = (formData: any) => {
    setTimer(8)
    let url = '/chrome_extension/v1/share',
    param = {
      email: formData.email,
      content: getCopyText(data)
    };
    axios({
      url,
      method: 'post',
      data: param
    })
      .then(originRes => {
        // console.log(originRes.data)
        clearTimer()
        if (originRes.data.code === 20000) {
          message('success', 'sucess')
          setIsShare(false)
        } else {
          message('submit faild!', 'warning')
        }

      })
      .catch(err => {
        message('submit faild!', 'error')
        clearTimer()
      })
  }

  const onSubmit = handleSubmit(onFormSummit)

  const close = useCallback(() => {
    const info = { 
        sign: 'detailClose',
        type: 'detailClose',
     }
    window.parent.postMessage(info, '*')
    onClose && onClose()
  }, [])

  const onCopy = useCallback(() => {
    oncopy(getCopyText(data, true))
    message('copy success', 'sucess')
  }, [data])

  return (
    <div onClick={e => e.stopPropagation()} className={`px-[20px] z-[9999999] fixed w-[100%] h-[80px] bottom-0 left-0 bg-white flex justify-between items-center shadow-xl ${pClassName}`}>
      <Loading
        loading={loading}
      />
      <Message />
      <div
        onClick={close}
        className=' rounded-[4px] cursor-pointer px-[24px] py-[10px] font-[500] font-Poppins text-black text-base border border-black hover:border-blue hover:text-blue'
      >
        {onClose ? 'BACK' : 'CLOSE'}
      </div>
      <div className='flex items-center'>

        <div onClick={() => { setIsShare(true) }} className='flex rounded-[4px] bg-black cursor-pointer px-[24px] py-[10px] mr-[20px] font-[500] text-base text-white'>
          <img
            alt='empty'
            className='w-[24px] h-[24px]'
            src={require('../../../img/share@3.png')}
          />
          <div className=' ml-[8px]'>SHARE</div>
        </div>

        <div onClick={openNewTab} className='flex rounded-[4px] bg-blue cursor-pointer px-[24px] py-[10px] font-[500] text-base text-white'>
          <div className=' mr-[8px]'>Go to Page</div>
          <img
            alt='empty'
            className='w-[24px] h-[24px]'
            src={require('../../../img/back@3.png')}
          />
        </div>

        {/* share */}
        <div 
          onClick={e => { e.stopPropagation(); setIsShare(false); }}
          className={`flex justify-center items-center w-[100%] h-[100vh] absolute left-0 bottom-0 bg-mask-bg-deep ${isShare ? '' : 'hidden'}`}
        >
          <div onClick={e => { e.stopPropagation() }} className='bg-white p-[36px] rounded-[12px] relative w-[760px] shadow-[0px 15px 75px rgba(0, 0, 0, 0.06)]'>
            <div onClick={() => { setIsShare(false) }} className=' absolute right-[16px] top-[14.13px] cursor-pointer'>
              <CloseOutlined />
            </div>
            <div className=' font-semibold text-2xl text-black'>Share This Property</div>
            <Input className=' pt-[17.2px] pb-[25.6px]' control={control} label="Email Address" name="email" rules={{ required: 'Please enter name' }} />
            <Card
              data={data}
            />
            <div className=' flex justify-between items-center mt-[24px]'>
              <div onClick={onCopy} className='py-[12px] text-center cursor-pointer rounded-[8px] border border-black hover:text-blue hover:border-blue flex-1 mr-[22px]'>Copy Share Text</div>
              <div onClick={onSubmit} className='py-[12px] text-center text-white cursor-pointer rounded-[8px] bg-blue flex-1 hover:bg-[#40a9ff]'>Send Email</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;


